export default __webpack_public_path__ + "static/media/icon_facility_milk.12433a27.svg";